export const ORDER_PER_BULAN_URL = 'dashboard/order_masuk_per_bulan'
export const ORDER_PER_BULAN_ERROR = 'ORDER_PER_BULAN_ERROR'
export const ORDER_PER_BULAN_LOADING = 'ORDER_PER_BULAN_LOADING'
export const ORDER_PER_BULAN_SUCCESS = 'ORDER_PER_BULAN_SUCCESS'